export enum TimePeriod {
    Day,
    Week,
    Month,
    Quarter,
    Year,
    All,
    SpecificRange,
}
